'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSubscribers = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _handlers = require('./handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initSubscribers = exports.initSubscribers = function initSubscribers() {
  PubSub.subscribe(_Constants2.default.newJoke, function (message, data) {
    return (0, _handlers.setNewJoke)(data);
  });

  PubSub.subscribe(_Constants2.default.toggleNavSearch, function (message, data) {
    return (0, _handlers.toggleHeaderSearch)(data);
  });

  PubSub.subscribe(_Constants2.default.closeNavSearch, function (message, data) {
    return (0, _handlers.closeHeaderSearch)(data);
  });

  PubSub.subscribe(_Constants2.default.toggleMenu, function (message, data) {
    return (0, _handlers.toggleMenuOpen)(data);
  });

  // Should close the menu if we aren't on a mobile sized screen
  PubSub.subscribe(_Constants2.default.resizeMenu, function (message, data) {
    if (!(0, _handlers.isMobile)()) {
      return (0, _handlers.closeMainMenu)(data);
    }
  });

  PubSub.subscribe(_Constants2.default.toggleMenuItemOpen, function (message, data) {
    return (0, _handlers.toggleMenuItemOpen)(data);
  });

  PubSub.subscribe(_Constants2.default.keyboardToggleCart, function (message, data) {
    return (0, _handlers.keyboardToggleCart)(data);
  });

  PubSub.subscribe('toggleNavigationMenu', function (message, data) {
    return (0, _handlers.setMobileNavigation)(data);
  });

  PubSub.subscribe('setUserNavigationType', function (message, data) {
    return (0, _handlers.setUserNavigationType)(data);
  });
};